<template>
    <Container :keyword="filter" :action="() => _get()">
        <PageHeader
            :perPage="false"
            :title="$options.name"
            :filter="filter"
            :action="() => _get()"
        >
            <ButtonFilter :action="() => _trigger()" />
            <ButtonExcel :action="() => _createExcel()" />
        </PageHeader>
        <DataTable
            :skeleton="filter.requested"
            :noData="!filter.requested && response.data.length == 0"
            :show="!filter.requested && response.data.length > 0"
            :filter="filter"
            :pagination="false"
            :meta="response.meta"
            :format="'table-no-break'"
        >
            <DataTableHeader :data="headers" :number="false" :action="true">
            </DataTableHeader>
            <tbody>
                <tr v-for="(row, i) in response.data" :key="i">
                    <td v-for="(header, j) in headers">
                        <template v-if="row[header]">{{ row[header] }}</template>
                    </td>
                </tr>
            </tbody>
        </DataTable>
        <FormFilter />
    </Container>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";
import { mapState, mapActions } from "vuex";
export default {
    name: "DistributionHistory",
    components: {
        FormFilter,
    },
    mixins: [helper],
    data() {
        return {
            headers: [
                "",
                "no_po",
                "no_invoice",
                "nama_driver",
                "total",
                "tanggal_jadwal",
                "created_at",
            ],
        };
    },
    computed: {
        ...mapState(["loading"]),
        ...mapState("distribution_history", {
            filter: (state) => state.filter,
            response: (state) => state.response,
        }),
    },
    methods: {
        ...mapActions("distribution_history", ["triggerModal", "getDistributionHistory"]),
        _trigger() {
            return this.triggerModal("filter");
        },
        _get() {
            this.getDistributionHistory().then((res) => {
                this._setHeaders(res);
                console.log(res);
            });
        },
        _setHeaders(res) {
            if (res.headers) {
                this.headers = res.headers;
            }
        },
        _createExcel() {
            this.createExcel({
                data: this.response.data,
                filename: "laporan-distribution-history",
            });
        },
    },
    mounted() {
        this._get();
    },
    created() {},
};
</script>
